import logger from '@adc/logger'
import { getCityLocationFromReverseLookup } from './googleMaps'

export const mapNavigatorPositionToLocation = position => {
  return new Promise((resolve, reject) => {
    // TODO: should we revisit this to refresh list if google isnt ready?
    // At this time we deemed it too late
    // Do not fire when filters are applied
    if (window.google) {
      const latitude = position.coords.latitude
      const longitude = position.coords.longitude
      return getCityLocationFromReverseLookup(latitude, longitude)
        .then(res => {
          const { location, zipcode } = res
          // expecting location in this format: Irvine, CA, USA
          const locationParts = location.split(',')
          return resolve({
            search_city: locationParts[0].trim(),
            search_state: locationParts[1].trim(),
            zipcode,
          })
        })
        .catch(error => {
          logger.debug(error)
          reject(error)
        })
    }
    return resolve({})
  })
}
